/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Public_Docs_Back_To_Document_RepositoryInputs */

const en_public_docs_back_to_document_repository = /** @type {(inputs: Public_Docs_Back_To_Document_RepositoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to document repository`)
};

const es_public_docs_back_to_document_repository = /** @type {(inputs: Public_Docs_Back_To_Document_RepositoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver al repositorio de documentos`)
};

/**
* | output |
* | --- |
* | "Back to document repository" |
*
* @param {Public_Docs_Back_To_Document_RepositoryInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const public_docs_back_to_document_repository = /** @type {((inputs?: Public_Docs_Back_To_Document_RepositoryInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Public_Docs_Back_To_Document_RepositoryInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_public_docs_back_to_document_repository(inputs)
	return en_public_docs_back_to_document_repository(inputs)
});